import React from 'react';

import classNames from 'classnames';

import withOnKeyDown from 'hoc/withOnKeyDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.css';

const VisibilityIcon = ({ onClick, onKeyDown, style, toggled }) => {
    const classes = classNames('visibility-icon', { toggled });

    return (
        <div className={classes} style={style} role="button" onClick={onClick} onKeyDown={onKeyDown} tabIndex={0}>
            {toggled && <FontAwesomeIcon icon="eye" className="app-icon" />}
            {!toggled && <FontAwesomeIcon icon="eye-slash" className="app-icon" />}
        </div>
    );
};

export default withOnKeyDown(VisibilityIcon);
